import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Dialog } from 'components/Dialog'
import { Text } from 'components/Text'
import { Heading } from 'components/Heading'
import { Stack } from 'components/Stack'
import { User } from 'models/user'
import { UserForm } from 'features/Organization/components/UserForm'
import { UserFormFields } from 'features/Organization/components/UserForm/UserForm'
import { useCreateUser } from 'services/user'

type InviteUserDialogProps = {
  isOpen: boolean
  onClose: () => void
  currentUser: User
}

export const InviteUserDialog: FC<InviteUserDialogProps> = ({ currentUser, isOpen, onClose }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [createUser, { status }] = useCreateUser()

  const onConfirm = (data: UserFormFields) => {
    return createUser(data, {
      onSuccess: (user: User) => {
        setTimeout(() => navigate(`/organization/users/${user.id}`), 500)
      },
    })
  }

  return (
    <Dialog aria-label={t('user.invite.dialog_label')} isOpen={isOpen} onClose={onClose}>
      <Stack>
        <header>
          <Heading size="secondary">{t('user.invite.title')}</Heading>
          <Text>{t('user.invite.desc')}</Text>
        </header>

        <UserForm currentUser={currentUser} onSubmit={onConfirm} status={status} />
      </Stack>
    </Dialog>
  )
}

InviteUserDialog.displayName = 'InviteUserDialog'
